var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiAtlasDark = function SvgAiAtlasDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.85,
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.6,
    cy: 7.1,
    r: 4.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 7.1h8.7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.6,
    cy: 7.1,
    rx: 2.05,
    ry: 4.35
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    d: "m11 1.6.4 1.35 1.35.4-1.35.4L11 5.1l-.4-1.35-1.35-.4 1.35-.4Z"
  })));
};
export default SvgAiAtlasDark;